import { Guid, Nillable } from '@web/utils';
import { PublicBoxCharacteristic } from './public-box-characteristic';
import { PublicSales } from '@web/shared/module/shop';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicBoxComponentGroup } from './public-box-component-group';

export class PublicBoxDetails {
  public constructor(
    private readonly data: {
      id: Guid;
      slug: string;
      name: string;
      price: number;
      sales: PublicSales;
      symbolSrc: string;
      symbolAlt: string;
      illustrationSrc: string;
      illustrationAlt: string;
      characteristics: PublicBoxCharacteristic[];
      groups: PublicBoxComponentGroup[];
      files: Multimedia[];
      contentPreviewUrl: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get name(): string {
    return this.data.name;
  }

  public get price(): number {
    return this.data.price;
  }

  public get sales(): PublicSales {
    return this.data.sales;
  }

  public get symbolSrc(): string {
    return this.data.symbolSrc;
  }

  public get symbolAlt(): string {
    return this.data.symbolAlt;
  }

  public get illustrationSrc(): string {
    return this.data.illustrationSrc;
  }

  public get illustrationAlt(): string {
    return this.data.illustrationAlt;
  }

  public get characteristics(): PublicBoxCharacteristic[] {
    return this.data.characteristics;
  }

  public get groups(): PublicBoxComponentGroup[] {
    return this.data.groups;
  }

  public get contentPreviewUrl(): Nillable<string> {
    return this.data.contentPreviewUrl;
  }

  public get files(): Multimedia[] {
    return this.data.files;
  }
}
